import { useMutation } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';
import getCurrentUser from './getCurrentUser';

const useUploadProfilePicture = () => {
  const getCurrentUserQuery = getCurrentUser();
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const response = await post<{ profilePicturePath: string }>(
        '/v1.0/user/profile-picture',
        formData,
      );
      return response.data;
    },
    onSuccess: () => {
      getCurrentUserQuery.refetch();
    },
  });
};

export default useUploadProfilePicture;
